import React, { useState, useEffect } from "react"; 
import { useLocation, useNavigate } from "react-router-dom";
import clienteAxios from "../helpers/axios.helper";
import Swal from "sweetalert2";

const ProductoABM = () => {
  const location = useLocation();
  const productoEnEdicion = location.state?.producto || null;
  const modoEdicion = location.state?.modoEdicion || false;
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [codigo, setCodigo] = useState("");
  const [generarCodigoGenerico, setGenerarCodigoGenerico] = useState(false);
  const [descripcion, setDescripcion] = useState("");
  const [imagen, setImagen] = useState("");
  const [precioVentaDolar, setPrecioVentaDolar] = useState("");
  const [precioVentaPeso, setPrecioVentaPeso] = useState("");
  const [mostrarPrecioEn, setMostrarPrecioEn] = useState("dolar");
  const [stock, setStock] = useState(0);
  const [disponible, setDisponible] = useState(true);
  const [categoria1Seleccionada, setCategoria1Seleccionada] = useState("");
  const [categoria2Seleccionada, setCategoria2Seleccionada] = useState("");
  const [categoria3Seleccionada, setCategoria3Seleccionada] = useState("");
  const [categoria1SeleccionadaEdicion, setCategoria1SeleccionadaEdicion] = useState("");
  const [categoria2SeleccionadaEdicion, setCategoria2SeleccionadaEdicion] = useState("");
  const [categoria3SeleccionadaEdicion, setCategoria3SeleccionadaEdicion] = useState("");
  const [categorias1, setCategorias1] = useState([]);
  const [categorias2, setCategorias2] = useState([]);
  const [categorias3, setCategorias3] = useState([]);
  const [marcaSeleccionada, setMarcaSeleccionada] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [anexo1, setAnexo1] = useState("");
  const [anexo2, setAnexo2] = useState("");
  const [anexo3, setAnexo3] = useState("");
  const [anexo4, setAnexo4] = useState("");
  const [anexo5, setAnexo5] = useState("");
  const [habilitarEdicionCategorias, setHabilitarEdicionCategorias] = useState(false); // Estado agregado para gestionar la edición de categorías
  
  const handleEdicionCategorias = () => {
    setHabilitarEdicionCategorias(!habilitarEdicionCategorias);
  };

  
  useEffect(() => {
    if (modoEdicion && productoEnEdicion) {
      setNombre(productoEnEdicion.nombre || "");
      setCodigo(productoEnEdicion.codigo || "");
      setDescripcion(productoEnEdicion.descripcion || "");
      setImagen(productoEnEdicion.imagen|| null);
      setStock(productoEnEdicion.stock || 0);
      if (productoEnEdicion.mostrar_precio_dolar) {
                setPrecioVentaDolar(productoEnEdicion.precioventadolar || 0);
        setMostrarPrecioEn('dolar');
      } else {
        setPrecioVentaPeso(productoEnEdicion.precioventapeso || 0);
        setMostrarPrecioEn('peso');
        
      }
      setDisponible(productoEnEdicion.disponible || false);
      setCategoria1Seleccionada(productoEnEdicion.categoria1_id || "");
      setCategoria2Seleccionada(productoEnEdicion.categoria2_id || "");
      setCategoria3Seleccionada(productoEnEdicion.categoria3_id || "");
      setMarcaSeleccionada(productoEnEdicion.marca_id || "");
      setAnexo1(productoEnEdicion.anexo1 || "");
      setAnexo2(productoEnEdicion.anexo2 || "");
      setAnexo3(productoEnEdicion.anexo3 || "");
      setAnexo4(productoEnEdicion.anexo4 || "");
      setAnexo5(productoEnEdicion.anexo5 || "");

    }
  }, [modoEdicion, productoEnEdicion]);
  
  const fetchCategorias1 = async () => {
    try {
      const response = await clienteAxios.get("/categorias/categoria1");
      setCategorias1(response.data);
    } catch (error) {
      console.error("Error al cargar las categorías1:", error);
    }
  };
  useEffect(() => {
    fetchCategorias1();

    const fetchMarcas = async () => {
      try {
        const response = await clienteAxios.get("/marcas");
        setMarcas(response.data);
      } catch (error) {
        console.error("Error al cargar las marcas:", error);
      }
    };
    fetchMarcas();
  }, []);

  const fetchCategorias2 = async () => {
    if (categoria1Seleccionada) {
      try {
        const response = await clienteAxios.get(`/categorias/categoria2/${categoria1Seleccionada}`);
        setCategorias2(response.data);
        setCategoria2Seleccionada("");
        setCategoria3Seleccionada("");
      } catch (error) {
        console.error("Error al cargar las categorías2:", error);
      }
    }
  };
  useEffect(() => {
    fetchCategorias2();
  }, [categoria1Seleccionada]);

  const fetchCategorias3 = async () => {
    if (categoria2Seleccionada) {
      try {
        const response = await clienteAxios.get(`/categorias/categoria3/${categoria1Seleccionada}/${categoria2Seleccionada}`);
        setCategorias3(response.data);
        setCategoria3Seleccionada("");
      } catch (error) {
        console.error("Error al cargar las categorías3:", error);
      }
    }
  };
  useEffect(() => {
    fetchCategorias3();
  }, [categoria2Seleccionada]);
  
  useEffect(() => {
    const cargarCategoriasEdicion = async () => {
      if (modoEdicion && productoEnEdicion?.categoria3_id) {
        try {
          // Cargar datos de categoría 3 y obtener el ID de categoría 2
          const categoria3Response = await clienteAxios.get(`/categorias/categoria3/${productoEnEdicion.categoria3_id}`);
          const categoria2Id = categoria3Response.data.categoria2_id;
          const categoria1Id = categoria3Response.data.categoria1_id;
          // Establecer categorías seleccionadas
          setCategoria3SeleccionadaEdicion({id:categoria3Response.data.categoria3_id,nombre:categoria3Response.data.categoria3_nombre});
          setCategoria2SeleccionadaEdicion({id:categoria3Response.data.categoria2_id,nombre:categoria3Response.data.categoria2_nombre});
          setCategoria1SeleccionadaEdicion({id:categoria3Response.data.categoria1_id,nombre:categoria3Response.data.categoria1_nombre});
 
          // Cargar categorías 1
          const categorias1Response = await clienteAxios.get("/categorias/categoria1");
          setCategorias1(categorias1Response.data);
          // Cargar categorías 2
          const categorias2Response = await clienteAxios.get(`/categorias/categoria2/${categoria1Id}`);
          setCategorias2(categorias2Response.data);
  
          // Cargar categorías 3
          const categorias3Response = await clienteAxios.get(`/categorias/categoria3/${categoria1Id}/${categoria2Id}`);
          setCategorias3(categorias3Response.data);
        } catch (error) {
          console.error("Error al cargar categorías en edición:", error);
        }
      }
    };
  
    cargarCategoriasEdicion();
  }, [modoEdicion, productoEnEdicion]);
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validar que la imagen esté seleccionada
    if (!imagen) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor, selecciona una imagen para el producto.",
      });
      return;
    }
  
    // Validar que todas las categorías estén seleccionadas
    if ((!modoEdicion) && (!categoria1Seleccionada || !categoria2Seleccionada || !categoria3Seleccionada)) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor, selecciona todas las categorías necesarias.",
      });
      return;
    }
    if ((modoEdicion && habilitarEdicionCategorias) && (!categoria1Seleccionada || !categoria2Seleccionada || !categoria3Seleccionada)) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor, selecciona todas las categorías necesarias.",
      });
      return;
    }
  
    // Validar que la marca esté seleccionada
    if (!marcaSeleccionada) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor, selecciona una marca.",
      });
      return;
    }
  
    // Validar que el precio ingresado tenga el formato decimal aceptado (ej. 20.99 o 20,99)
    // La expresión regular permite uno o más dígitos, opcionalmente seguidos de un separador (punto o coma) y uno o dos dígitos
    const precioRegex = /^\d+(?:[.,]\d{1,2})?$/;
  
    if (mostrarPrecioEn === "dolar") {
      if (!precioRegex.test(precioVentaDolar)) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor, ingresa un precio válido en formato decimal (ej: 20.99 o 20,99) para el precio en dólares.",
        });
        return;
      }
    }
  
    if (mostrarPrecioEn === "peso") {
      if (!precioRegex.test(precioVentaPeso)) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor, ingresa un precio válido en formato decimal (ej: 20.99 o 20,99) para el precio en pesos.",
        });
        return;
      }
    }
  
    // Convertir el precio, reemplazando la coma por punto si es necesario
    const precioVentaDolarDecimal = mostrarPrecioEn === "dolar" ? parseFloat(precioVentaDolar.replace(",", ".")) : 0;
    const precioVentaPesoDecimal = mostrarPrecioEn === "peso" ? parseFloat(precioVentaPeso.replace(",", ".")) : 0;
  
    const productoData = {
      nombre: nombre,
      codigo: generarCodigoGenerico ? -1 : codigo,
      descripcion: descripcion,
      imagen: imagen || productoEnEdicion.imagen,
      precioVentaDolar: precioVentaDolarDecimal,
      precioVentaPeso: precioVentaPesoDecimal,
      mostrar_precio_dolar: mostrarPrecioEn === "dolar" ? 1 : 0,
      stock: parseInt(stock),
      disponible: disponible,
      categoria1_id: parseInt(categoria1Seleccionada) || productoEnEdicion.categoria1_id,
      categoria2_id: parseInt(categoria2Seleccionada) || productoEnEdicion.categoria2_id,
      categoria3_id: parseInt(categoria3Seleccionada) || productoEnEdicion.categoria3_id,
      marca_id: parseInt(marcaSeleccionada),
      anexo1: anexo1,
      anexo2: anexo2,
      anexo3: anexo3,
      anexo4: anexo4,
      anexo5: anexo5,
      estaEliminado: false,
    };
  
    try {
      Swal.fire({
        title: "Guardando...",
        text: "Por favor espera mientras se procesa la acción.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      
      if (modoEdicion) {
        const response = await clienteAxios.put(`/productos/${productoEnEdicion.id}`, productoData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.status === 200) {
          Swal.close();
          Swal.fire({
            icon: "success",
            title: "¡Producto actualizado con éxito!",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            navigate('/panel_administracion');
          }, 1000);
        }
      } else {
        const response = await clienteAxios.post("/productos", productoData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
    
        if (response.status === 200) {
          Swal.close();
          Swal.fire({
            icon: "success",
            title: "¡Producto creado con éxito!",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            navigate('/panel_administracion');
          }, 1000);
        }
      }
    } catch (error) {
      Swal.close();
      if (error.response) {
        console.error("Error en la respuesta del servidor:", error.response);
    
        if (error.response.status === 400) {
          const errorMessage = error.response.data.error;
          Swal.fire({
            icon: "error",
            title: "Error al subir el archivo",
            text: errorMessage || "Ocurrió un error inesperado al subir la imagen.",
          });
          return;
        }
      }
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al guardar el producto. Por favor, inténtalo nuevamente.",
      });
    }
  };
  return (
    <div className="p-6 max-w-4xl mx-auto bg-white my-10 border-2 border-GrisOscuro rounded-md">
      <h1 className="text-2xl font-bold mb-4">
        {modoEdicion ? "Editar Producto" : "Nuevo Producto"}
      </h1>

      <form onSubmit={handleSubmit}>
  {/* Nombre */}
  <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Nombre</label>
    <input
      type="text"
      className="w-full p-2 border rounded-md"
      value={nombre}
      onChange={(e) => setNombre(e.target.value)}
      required
    />
  </div>

  {/* Código */}
  <div className="mb-4">
  <label className="block text-gray-700 font-medium mb-2">
    Código
    <input
      type="checkbox"
      className="ml-2"
      checked={generarCodigoGenerico}
      onChange={(e) => setGenerarCodigoGenerico(e.target.checked)}
      disabled={modoEdicion}  // Deshabilitar checkbox si está en modo edición
    />
    Generar automático
  </label>

  {modoEdicion ? (
    // Si está en edición, solo mostramos el valor del código sin permitir cambios
    <input
      type="text"
      className="w-full p-2 border rounded-md"
      value={codigo}
      disabled={true}  // Deshabilitar el campo si está en edición
    />
  ) : (
    // Si no está en edición, el campo es editable
    <input
      type="text"
      className="w-full p-2 border rounded-md"
      value={codigo}
      onChange={(e) => setCodigo(e.target.value)}
      disabled={generarCodigoGenerico}  // Deshabilitar campo si "Generar automático" está activado
    />
  )}
</div>


  {/* Descripción */}
  <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Descripción</label>
    <textarea
      className="w-full p-2 border rounded-md"
      value={descripcion}
      onChange={(e) => setDescripcion(e.target.value)}
      required
    ></textarea>
  </div>

  {/* URL de imagen */}
  <div className="mb-4">
  <label className="block text-gray-700 font-medium mb-2">Subir imagen</label>
  <input
    type="file"
    name="imagen"
    className="w-full p-2 border rounded-md"
    onChange={(e) => setImagen(e.target.files[0])}
  />
</div>


   {/* Precio */}
   <div className="mb-4">
        <label className="block text-gray-700 font-medium mb-2">Precio</label>
        <div className="flex space-x-4">
          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="mostrarPrecioEn"
              value="dolar"
              checked={mostrarPrecioEn === "dolar"}
              onChange={(e) => setMostrarPrecioEn(e.target.value)}
            />
            <span>Dólar</span>
          </label>
          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="mostrarPrecioEn"
              value="peso"
              checked={mostrarPrecioEn === "peso"}
              onChange={(e) => setMostrarPrecioEn(e.target.value)}
            />
            <span>Peso</span>
          </label>
        </div>
        {mostrarPrecioEn === "dolar" && (
          <input
            type="text"
            className="w-full p-2 border rounded-md"
            value={precioVentaDolar}
            onChange={(e) => setPrecioVentaDolar(e.target.value)}
          />
        )}
        {mostrarPrecioEn === "peso" && (
          <input
            type="text"
            className="w-full p-2 border rounded-md"
            value={precioVentaPeso}
            onChange={(e) => setPrecioVentaPeso(e.target.value)}
          />
        )}
      </div>

  {/* Stock */}
  <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Stock</label>
    <input
      type="number"
      className="w-full p-2 border rounded-md"
      value={stock}
      onChange={(e) => setStock(e.target.value)}
      min="0"
      required
    />
  </div>

  {/* Disponible */}
  <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Disponible</label>
    <input
      type="checkbox"
      className="ml-2"
      checked={disponible}
      onChange={(e) => setDisponible(e.target.checked)}
    />
  </div>

   {/* Categorías */}
   <div className="mb-4">
      <label className="block text-gray-700 font-medium mb-2">Categorías</label>
          {!habilitarEdicionCategorias && modoEdicion ? (
            <div>
          <input
            type="text"
            value={categoria1SeleccionadaEdicion.nombre}
            className="w-full p-2 border rounded-md mb-2"
            readOnly
          />
          <input
            type="text"
            value={categoria2SeleccionadaEdicion.nombre}
            className="w-full p-2 border rounded-md mb-2"
            readOnly
          />
          <input
            type="text"
            value={categoria3SeleccionadaEdicion.nombre}
            className="w-full p-2 border rounded-md"
            readOnly
          />
        </div>
      ) : (
        <>
          <select
            value={categoria1Seleccionada}
            onChange={(e) => setCategoria1Seleccionada(e.target.value)}
            className="w-full p-2 border rounded-md mb-2"
          >
            <option value="">Seleccione Categoría 1</option>
            {categorias1.map((cat1) => (
              <option key={cat1.id} value={cat1.id}>
                {cat1.nombre}
              </option>
            ))}
          </select>
          <select
            value={categoria2Seleccionada}
            onChange={(e) => setCategoria2Seleccionada(e.target.value)}
            className="w-full p-2 border rounded-md mb-2"
            disabled={!categoria1Seleccionada}
          >
            <option value="">Seleccione Categoría 2</option>
            {categorias2.map((cat2) => (
              <option key={cat2.id} value={cat2.id}>
                {cat2.nombre}
              </option>
            ))}
          </select>
          <select
            value={categoria3Seleccionada}
            onChange={(e) => setCategoria3Seleccionada(e.target.value)}
            className="w-full p-2 border rounded-md"
            disabled={!categoria2Seleccionada}
          >
            <option value="">Seleccione Categoría 3</option>
            {categorias3.map((cat3) => (
              <option key={cat3.id} value={cat3.id}>
                {cat3.nombre}
              </option>
            ))}
          </select>
        </>
          )}
          {
       modoEdicion &&
      <div className="mt-2">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            checked={habilitarEdicionCategorias}
            onChange={handleEdicionCategorias}
            className="mr-2"
          />
          Habilitar edición de categorías
        </label>
      </div>
          }
    </div>

  {/* Marca */}
  <div className="mb-4">
    <label className="block text-gray-700 font-medium mb-2">Marca</label>
    <select
      className="w-full p-2 border rounded-md"
      value={marcaSeleccionada}
      onChange={(e) => setMarcaSeleccionada(e.target.value)}
    >
      <option value="">Selecciona una marca</option>
      {marcas.map((marca) => (
        <option key={marca.id} value={marca.id}>
          {marca.nombre}
        </option>
      ))}
    </select>
  </div>

   {/* Sección para anexos */}
   {[anexo1, anexo2, anexo3, anexo4, anexo5].map((anexo, index) => (
  <div key={index} className="mb-4">
    <h3 className="text-lg font-semibold">Anexo {index + 1}</h3>
    <input
      type="text"
      className="w-full p-2 border rounded-md mb-2"
      placeholder="Valor del Anexo"
      value={anexo}
      onChange={(e) => {
        const newValue = e.target.value;
        switch (index) {
          case 0:
            setAnexo1(newValue);
            break;
          case 1:
            setAnexo2(newValue);
            break;
          case 2:
            setAnexo3(newValue);
            break;
          case 3:
            setAnexo4(newValue);
            break;
          case 4:
            setAnexo5(newValue);
            break;
          default:
            break;
        }
      }}
    />
  </div>
))}

  <button
    type="submit"
    className="w-full bg-blue-500 text-white p-2 rounded-md"
  >
    {modoEdicion ? "Actualizar Producto" : "Crear Producto"}
  </button>
</form>

    </div>
  );
};

export default ProductoABM;